import { Divider, Text } from '@wework/dieter-ui'
import React, { useState, FunctionComponent } from 'react'
import './styles.css'
import {
  DrywallIcon,
  ObstructionIcon,
  ExternalWindowIcon,
  InternalRoomsIcon,
  HighLightIcon,
  HighViewIcon,
  RightArrow,
} from '../Icons'
import Row from '../Common/Row'
import IMTheme from '../../style/IMTheme'

export enum LightQuality {
  ABOVE_AVERAGE_LIGHT = 'Above Average',
  AVERAGE_LIGHT = 'Average',
  BELOW_AVERAGE_LIGHT = 'Below Average',
  UNKNOWN_LIGHT = 'Unknown Light',
}

export enum ViewQuality {
  WINDOW_ABOVE_AVERAGE_VIEW = 'Window - Above average',
  WINDOW_AVERAGE_VIEW = 'Window - Average',
  WINDOW_BELOW_AVERAGE_VIEW = 'Window - Below average',
  UNKNOWN_VIEW = 'Unknown View',
  'NO_WINDOW_VIEW' = 'No Window - View',
  'NO_WINDOW_NO_VIEW' = 'No Window - No View',
}

interface SpaceAttributesProps {
  space: any
  isColapsable?: boolean
}

const SpaceAttributes: FunctionComponent<SpaceAttributesProps> = ({
  space,
  isColapsable = true,
}) => {
  const [collapsed, setCollapsed] = useState(false)
  if (!space || !space.reservable) {
    return null
  }

  const { inventoryData } = space
  if (!inventoryData) {
    return null
  }

  return (
    <>
      <Row style={{ marginBottom: IMTheme.spacing[4] }}>
        <Text
          style={{
            fontWeight: IMTheme.fontWeights.bold,
            fontSize: IMTheme.fontSizes[2],
          }}
        >
          Attributes
        </Text>
        {isColapsable && (
          <div
            onClick={() => setCollapsed(!collapsed)}
            style={{
              cursor: 'pointer',
              transform: collapsed ? 'rotate(-90deg)' : 'rotate(90deg)',
              width: 12,
              height: 12,
            }}
          >
            <RightArrow />
          </div>
        )}
      </Row>
      {!collapsed && (
        <div style={{ flexDirection: 'column', display: 'flex' }}>
          {' '}
          {inventoryData?.internal_room_count && (
            <Row
              style={{ marginBottom: IMTheme.spacing[4] }}
              justify={'flex-start'}
            >
              <InternalRoomsIcon />
              <Text size="tiny" style={{ marginLeft: IMTheme.spacing[2] }}>
                {inventoryData?.internal_room_count} Internal rooms
              </Text>
            </Row>
          )}
          <Row
            style={{ marginBottom: IMTheme.spacing[4] }}
            justify={'flex-start'}
          >
            <ExternalWindowIcon />
            <Text size="tiny" style={{ marginLeft: IMTheme.spacing[2] }}>
              {inventoryData?.has_window ? 'External window' : 'No Window'}
            </Text>
          </Row>
          {inventoryData?.view_quality &&
            inventoryData?.view_quality !== 'UNKNOWN_VIEW' && (
              <Row
                style={{ marginBottom: IMTheme.spacing[4] }}
                justify={'flex-start'}
              >
                <HighViewIcon />
                <Text size="tiny" style={{ marginLeft: IMTheme.spacing[2] }}>
                  {ViewQuality[inventoryData.view_quality]}
                </Text>
              </Row>
            )}
          {inventoryData?.light_quality &&
            inventoryData?.light_quality !== 'UNKNOWN_LIGHT' && (
              <Row
                style={{ marginBottom: IMTheme.spacing[4] }}
                justify={'flex-start'}
              >
                <HighLightIcon />

                <Text size="tiny" style={{ marginLeft: IMTheme.spacing[2] }}>
                  {LightQuality[inventoryData.light_quality]}
                </Text>
              </Row>
            )}
          {inventoryData?.obstructions > 0 && (
            <Row
              style={{ marginBottom: IMTheme.spacing[4] }}
              justify={'flex-start'}
            >
              <ObstructionIcon />
              <Text size="tiny" style={{ marginLeft: IMTheme.spacing[2] }}>
                {inventoryData?.obstructions} obstructions
              </Text>
            </Row>
          )}
          {inventoryData?.has_solid_wall && (
            <Row
              style={{ marginBottom: IMTheme.spacing[4] }}
              justify={'flex-start'}
            >
              <DrywallIcon />

              <Text size="tiny" style={{ marginLeft: IMTheme.spacing[2] }}>
                Has Solid wall
              </Text>
            </Row>
          )}
          {/* <Row style={{ marginBottom: IMTheme.spacing[4] }} justify={'flex-start'}>
            <PremiumFloorIcon />
            <Text size="tiny" style={{ marginLeft: IMTheme.spacing[2] }}>
              Premium floor
            </Text>
          </Row> */}
        </div>
      )}
      <Divider light style={{ margin: '8px 0 20px 0' }} />
    </>
  )
}

export default SpaceAttributes
